import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberUtil, PhoneNumberFormat, PhoneNumber } from 'google-libphonenumber';
interface PhoneFormatConfig {
    [countryCode: string]: string;
}

@Pipe({ name: 'phoneNumberFormat' })
export class PhoneNumberFormatPipe implements PipeTransform {
    transform(value: string, countryPhoneCode: string): string {
        const phoneNumberUtil = PhoneNumberUtil.getInstance();
        let formattedNumber = '';

        try {
            const phoneNumber: PhoneNumber = phoneNumberUtil.parseAndKeepRawInput(value, `${countryPhoneCode}`);
            formattedNumber = phoneNumberUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
        } catch (e) {
            console.error(`Invalid phone number ${value} for country phone code ${countryPhoneCode}: ${e.message}`);
            formattedNumber = value;
        }

        return formattedNumber;
    }
}
